import $ from 'jquery';

class HomeSlider {
  constructor() {
    this.sliders = $('.js-home-slider');

    this.slidersInit();
  }

  slidersInit() {
    if (!this.sliders.length) {
      return;
    }

    this.sliders.each((i, el) => {
      const slider = $(el);

      slider.flexslider({
        animation: 'fade',
        slideshowSpeed: 9000,
        animationSpeed: 1500,
        controlNav: false,
        startAt: i * 3,
        directionNav: false,
      });
    });
  }
}

export default HomeSlider;



// WEBPACK FOOTER //
// ./src/scripts/modules/home-slider.js